import { MessageCircle } from 'lucide-react';
import { useState } from 'react';

export default function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '40787683304';
  const message = encodeURIComponent('Bună ziua! Aș dori mai multe informații despre ControlMax.');

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        aria-label="Contactează-ne pe WhatsApp"
      >
        <MessageCircle className="w-7 h-7" />

        {isHovered && (
          <div className="absolute right-full mr-3 whitespace-nowrap bg-gray-900 text-white px-3 py-2 rounded-lg text-sm shadow-lg">
            Scrie-ne pe WhatsApp
            <div className="absolute top-1/2 -right-1 -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
          </div>
        )}
      </button>

      <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#25D366] rounded-full animate-ping"></div>
    </div>
  );
}
